var $ = $ || jQuery;

$(window).on('scroll resize load', function(e){
    let y = (window.pageYOffset !== undefined)
  ? window.pageYOffset
  : (document.documentElement || document.body.parentNode || document.body).scrollTop;

  var scrollPercent = ( y / ((document.documentElement || document.body.parentNode || document.body).scrollHeight - window.innerHeight ) ) * 100;

  var step = 1;
  document.body.setAttribute("data-scrolled", Math.ceil(scrollPercent / step) * step );
      
  if(y>0){
    document.body.classList.add('scrolled');
  }else{
    document.body.classList.remove('scrolled'); 
  }

  
   
} );





function ismatch(str){
  var ret = null;
  var tab = ['data-aos_', 'data-aos-delay_', 'data-aos-duration_', 'data-aos-easing_', 'data-aos-anchor-placement_'];
  Object.values(tab).forEach( function (value) {
      if (String(str).match(value)){
          ret = str.split('_');
          return false;
      }
  });
  return ret;
}
$(function(){
  var $hhh = $('<div class="header-height-holder" />')
  $('>header', '.wp-site-blocks').after($hhh);
  $(window).on('scroll resize load', function(e){
    $hhh.css({height: Math.ceil($hhh.siblings('header').innerHeight()) });
    });



  $('.data-aos').each(function () {
    var $this = $(this);
    var tab = $this.attr('class').split(' ');
    var keep;
    Object.values(tab).forEach(function (item) {
        var ello = ismatch(item) 
        if (ello !== null)
            $this.attr(ello[0], ello[1]);
        });
        
    });
    AOS.init({
      delay: 300
    });

    $('.table-mobiled table').each(function () {
      
      var newTable = $('<table class="is-mobile-ready"><tbody></tbody></table>');
      $('tr>th, tr>td', this).each(function(ind,elm){ 

      //console.log('ovo', ind, $('tr',newTable).eq( ind ).length, $(elm).index());

       var newRow =  $('tr',newTable).eq( $(elm).index() ).length ? $('tr',newTable).eq( $(elm).index() ) : $('<tr></tr>');
       $(this).clone().appendTo(newRow);
       if(!$('tr',newTable).eq( $(elm).index() ).length){
         newRow.appendTo(newTable);
       }
      })

      $(this).before(newTable);

    });

    $('.has-colgroup').each((ind,elm)=>{
      let nc = $('tbody tr:first-child td', elm).length;
      let colg = $('table', elm).prepend('<colgroup/>');
      for (let i= 0; i < nc; i++ ){
        $('colgroup', elm).prepend('<col>');
      }
    })

});


jQuery(function($){
    $('[data-iframebg]').each(function(ind,el){
        var vholder = $('<div class="z-index-0 iframe-holder" />');
        var viframe = $('<iframe type="text/html" loading="lazy" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" class="" src="'+this.dataset.iframebg+'" />')
        .on("load", function() {
            $(this).parent().addClass('show').parent().addClass('has-video-bg');
        });

        vholder.append(viframe);

        this.dataset && this.dataset.iframebg && $('.wp-block-cover__inner-container', this).before(vholder);
    });

    $('[rel="next-block"]').each(function(ind,elm){
      var nb = $(this).closest('.scroll-reference-block').next();
      var clss = nb.attr('class');
      if(clss){
        clss = clss.replace(/\s/g, '.');
        clss = '.'+ clss;
      }
      $(this).closest('.scrollToAnchor').attr('data-target', clss );
    });


    $('.is-tabs').each((ind,elm)=>{
      let tabs = $(elm).children();
      let nav = $('<nav><div class="nav nav-tabs" id="nav-tab-'+(Math.random()*1001|0)+'" role="tablist"></div></nav>');
      let tbs = $('<div class="tab-content" id="nav-tabContent"></div>');      

      $(tabs).each((inx,tb)=>{
        let rand = Math.random()*10001|0;
        let txt =  $(tb).children().first().text();
        let txtS = (txt||'').replace(' ', '-').toLowerCase();
        let act = inx===0 ? 'active' : '';
        let btn = $('<button class="nav-link '+act+'" id="nav-'+ txtS+rand +'-tab" data-bs-toggle="tab" data-bs-target="#'+txtS+rand+'" type="button" role="tab" aria-controls="nav-'+txtS+rand+'" aria-selected="true">'+txt+'</button>');
        
        $('.nav-tabs', nav).append(btn);

        let actS = inx===0 ? 'show active' : '';
        let ttab = $('<div class="tab-pane fade '+actS+'" id="'+txtS+rand+'" role="tabpanel" aria-labelledby="nav-'+ txtS+rand +'-tab"></div>');
        $(tb).appendTo(ttab);
        $(ttab).appendTo(tbs);

      });
      nav.prependTo(elm);
      tbs.appendTo(elm);
    })

});


/**
 * Function that actually perform scrolling
 * @method smoothScrollIt
 * @param {Class | ID} target identifies target element
 * @param {Number} [scrollOffset=50] number of pixels for top offset
 * @param {Number} [dataSpeed=700] miliseconds
 */
 function smoothScrollIt(target, scrollOffset, dataSpeed){
	if (target.length) {
		$scrollOffset = scrollOffset || 50;
		$dataSpeed = dataSpeed || 700;
		$('html,body').animate({
			scrollTop: $(target).offset().top - $scrollOffset
		}, $dataSpeed);
		return false;
	}
}	//	/function smoothScrollIt()

/**
 * Scroll To Anchor Link
 * @interface
 * @param {Class | ID} data-target identifies target element
 * @param {Number} data-offset number of pixels for top offset
 * @param {Number} data-speed miliseconds
 */
 $(document).on('click', '.scrollToAnchor', function(e) {
	//e.preventDefault();
  console.log('click');
	var target = $(this).attr('data-target');
  console.log(target);
	var scrollOffset = $(this).attr('data-offset') ? $(this).attr('data-offset') : 75;
	var dataSpeed = $(this).attr('data-speed') ? $(this).attr('data-speed') : 700;
	target = target.length ? $(target) : $('[name=' + target +']');
	// console.log('scroll');
	if (target.length) {
		smoothScrollIt(target, scrollOffset, dataSpeed  );
		return false;
	}
});
// scroll to anchor function END

